import React from "react";
import { PartyBar } from "./PartyBar.js";
import { MiniMap } from "./MiniMap.js";
import { CombatLog } from "./CombatLog.js";
import { ReactionPrompt } from "./ReactionPrompt.js";
import { DialogueBox } from "./DialogueBox.js";
import { MainMenu } from "./MainMenu.js";
import { EscChip } from "./EscChip.js";

interface DesktopHUDProps {
  showMenu: boolean;
  onCloseMenu: () => void;
}

const PANEL_BASE: React.CSSProperties = {
  background: "rgba(8, 10, 18, 0.90)",
  display: "flex",
  flexDirection: "column",
  pointerEvents: "auto",
  overflowY: "auto",
};

export function DesktopHUD({ showMenu, onCloseMenu }: DesktopHUDProps) {
  return (
    <>
      {/* Three-column shell: left panel | transparent center | right panel */}
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      >
        {/* Left panel — party stats */}
        <div
          style={{
            ...PANEL_BASE,
            width: 200,
            borderRight: "1px solid rgba(255,255,255,0.12)",
          }}
        >
          <PartyBar panel />
        </div>

        {/* Center — transparent; Three.js canvas shows through */}
        <div style={{ flex: 1, pointerEvents: "none" }} />

        {/* Right panel — minimap + combat log */}
        <div
          style={{
            ...PANEL_BASE,
            width: 240,
            borderLeft: "1px solid rgba(255,255,255,0.12)",
          }}
        >
          <MiniMap panel />
          <CombatLog panel />
        </div>
      </div>

      {/* Full-screen overlays — sit above the shell */}
      <EscChip />
      <ReactionPrompt />
      <DialogueBox />
      {showMenu && <MainMenu onClose={onCloseMenu} />}
    </>
  );
}
